import {
    getStorage,
    ref as storageRef,
    getMetadata,
    updateMetadata,
    deleteObject
  } from 'firebase/storage';
  
  /**
   * Remove do metadata o uso indicado e, se não sobrar nenhum uso,
   * deleta o objeto do Storage.
   * Se o objeto não existir, só loga e retorna.
   *
   * @param {string} path         — caminho no bucket (e.g. "images/abc.png")
   * @param {{categoryId,cardId,videoId}} removalRef
   */
  export async function safeRemoveStorageUsage(path, removalRef) {
    const storage = getStorage();
    const fileRef = storageRef(storage, path);
  
    let meta;
    try {
      // Tenta ler metadados
      meta = await getMetadata(fileRef);
    } catch (e) {
      if (e.code === 'storage/object-not-found') {
        console.warn(`Arquivo não encontrado (já deletado?): ${path}`);
        return;            // pula esse arquivo sem estourar erro
      }
      throw e;             // rethrow outros erros
    }
  
    const existingCustom = meta.customMetadata || {};
    const usos = existingCustom.usages ? JSON.parse(existingCustom.usages) : [];
  
    // Filtra o uso que queremos remover
    const filtered = usos.filter(u => {
      // se removalRef.videoId é undefined, só checa category+card
      if (removalRef.videoId !== undefined) {
        return !(
          u.categoryId === removalRef.categoryId &&
          u.cardId     === removalRef.cardId &&
          u.videoId    === removalRef.videoId
        );
      }
      return !(
        u.categoryId === removalRef.categoryId &&
        u.cardId     === removalRef.cardId
      );
    });
  
    if (filtered.length === 0) {
      // nenhum uso restante → deleta o arquivo
      await deleteObject(fileRef);
      console.log(`Deletado do Storage: ${path}`);
    } else {
      // ainda há usos → só atualiza metadata
      const newCustom = {
        ...existingCustom,
        usages: JSON.stringify(filtered)
      };
      await updateMetadata(fileRef, { customMetadata: newCustom });
      console.log(`Metadata Storage atualizado em ${path}:`, filtered);
    }
  }
  